import { Star } from "lucide-react";
import { REVIEWS, REVIEW_STATS } from "../data/reviews";
import { BUSINESS } from "../data/business";

function Stars({ n = 5 }) {
  return (
    <div className="flex gap-1 text-[var(--beautix-gold)]">
      {Array.from({ length: n }).map((_, i) => (
        <Star key={i} className="w-4 h-4 fill-current" strokeWidth={0} />
      ))}
    </div>
  );
}

export default function Reviews({ compact = false }) {
  const list = compact ? REVIEWS.slice(0, 3) : REVIEWS;

  return (
    <section
      className="relative py-24 md:py-32 bg-[var(--beautix-cream)] overflow-hidden"
      data-testid="reviews-section"
      aria-label="Opinie klientek BEAUTIX Katowice"
    >
      <div className="absolute inset-0 grain" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end mb-16">
          <div className="lg:col-span-7">
            <p className="eyebrow mb-4">Głosy naszych klientek</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              117 opinii, średnia
              <span className="text-[var(--beautix-pink)] italic"> 4,9 na 5</span>
              <span className="text-[var(--beautix-muted)]"> — mówią same za siebie.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 flex flex-col gap-4 lg:items-end">
            <div className="flex items-center gap-4">
              <div className="text-6xl font-serif-display text-[var(--beautix-pink)] leading-none">
                {REVIEW_STATS.average}
              </div>
              <div>
                <Stars />
                <p className="text-xs text-[var(--beautix-muted)] mt-1">
                  {REVIEW_STATS.total} zweryfikowanych opinii
                </p>
              </div>
            </div>
            <div className="flex flex-wrap gap-3 text-xs">
              {REVIEW_STATS.sources.map((s) => (
                <span
                  key={s.name}
                  className="px-3 py-1.5 rounded-full bg-white border border-[var(--beautix-line)] text-[var(--beautix-muted)]"
                  data-testid={`review-source-${s.name.toLowerCase()}`}
                >
                  {s.name} · {s.count} ({s.avg.toFixed(1)})
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((r, i) => (
            <article
              key={r.author + i}
              data-testid={`review-card-${i}`}
              className="bg-white p-8 border border-[var(--beautix-line)] flex flex-col gap-5 group hover:border-[var(--beautix-pink)] transition-colors"
            >
              <div className="flex items-center justify-between">
                <Stars n={r.rating} />
                <span className="text-[10px] tracking-[0.28em] uppercase text-[var(--beautix-muted)]">
                  {r.source}
                </span>
              </div>
              <p className="font-serif-display text-xl leading-snug text-[var(--beautix-ink)]">
                &bdquo;{r.text}&rdquo;
              </p>
              <div className="mt-auto flex items-center gap-4 pt-4 border-t border-[var(--beautix-line)]">
                <div className="w-10 h-10 rounded-full bg-[var(--beautix-blush)] text-[var(--beautix-pink-dark)] flex items-center justify-center font-medium text-sm">
                  {r.initials}
                </div>
                <div>
                  <p className="text-sm font-medium text-[var(--beautix-ink)]">
                    {r.author}
                  </p>
                  <p className="text-xs text-[var(--beautix-muted)]">{r.service}</p>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-14 flex flex-col md:flex-row md:items-center md:justify-between gap-6 pt-10 border-t border-[var(--beautix-line)]">
          <div className="flex flex-wrap gap-2 items-center">
            {REVIEW_STATS.awards.map((a) => (
              <span
                key={a}
                className="text-xs tracking-wide px-3 py-1.5 rounded-full border border-[var(--beautix-gold-soft)] text-[var(--beautix-gold)] bg-white"
              >
                🏆 {a}
              </span>
            ))}
          </div>
          <a
            href={BUSINESS.googleReviewUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="see-more-google-btn"
            className="inline-flex items-center gap-2 text-sm font-medium text-[var(--beautix-pink)] link-underline"
          >
            Zobacz wszystkie opinie w Google →
          </a>
        </div>
      </div>
    </section>
  );
}
